import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { fetchMyHubupCommunities } from '../api/hubup';

const HubupCommunitiesContext = createContext(null);

export function HubupCommunitiesProvider({ children }) {
  const [communities, setCommunities] = useState([]);
  const [noAssignment, setNoAssignment] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetchMyHubupCommunities();
      setCommunities(res?.data?.communities || []);
      setNoAssignment(res?.data?.noAssignment === true);
    } catch (e) {
      setError(e?.message || 'Impossible de charger vos communautés.');
      setCommunities([]);
      setNoAssignment(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const value = useMemo(
    () => ({
      communities,
      loading,
      error,
      noAssignment,
      refetch: load,
    }),
    [communities, loading, error, noAssignment, load],
  );

  return (
    <HubupCommunitiesContext.Provider value={value}>
      {children}
    </HubupCommunitiesContext.Provider>
  );
}

export function useHubupCommunitiesOptional() {
  return useContext(HubupCommunitiesContext);
}

export function useHubupCommunities() {
  const ctx = useContext(HubupCommunitiesContext);
  if (!ctx) {
    throw new Error('useHubupCommunities must be used within HubupCommunitiesProvider');
  }
  return ctx;
}
